import { getDefaultLang } from "@cervval.js/common/src/i18n/languages";

const _fr = {
    addProduct: "Ajouter un produit",
    emptyTd: "Vous n'avez aucun produit enregistré",
    deleteProductTooltip: "Supprimer ce produit",
    deleteProductDialogTitle: "Supprimer un produit",
    deleteProductHeaderHtmlTemplate: (productName: string) => `Souhaitez-vous supprimer le produit ${productName} ?`
};

export type _I18nProductPage = typeof _fr;

const _en: _I18nProductPage = {
    addProduct: "Add a product",
    emptyTd: "No products are registered",
    deleteProductTooltip: "Remove this product",
    deleteProductDialogTitle: "Remove a product",
    deleteProductHeaderHtmlTemplate: (productName: string) => `Do you wish to remove the product ${productName} ?`
};

/**
 * Return value in required language
 * @param lang Chosen lang
 * @returns 
 */
export function I18nProductPage(lang?: string): _I18nProductPage {
    lang = lang ?? getDefaultLang();
    switch (lang) {
        case "en":
            return _en;
        case "fr":
        default:
            return _fr;
    }
}